var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5590_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z",
    fill: "url(#paint0_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.997 9L29.71 9.96267V37.8946L29.997 38.1773L43.1272 30.5133L29.997 9Z",
    fill: "url(#paint1_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9968 9L16.8662 30.5133L29.9968 38.1773V24.6199V9Z",
    fill: "url(#paint2_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9967 40.6317L29.835 40.8265V50.7762L29.9967 51.2425L43.135 32.9717L29.9967 40.6317Z",
    fill: "url(#paint3_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9968 51.2425V40.6317L16.8662 32.9717L29.9968 51.2425Z",
    fill: "url(#paint4_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9971 38.1775L43.1273 30.5135L29.9971 24.6201V38.1775Z",
    fill: "url(#paint5_linear_5590_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8662 30.5135L29.9968 38.1775V24.6201L16.8662 30.5135Z",
    fill: "url(#paint6_linear_5590_519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5590_519",
    x1: 13.125,
    y1: -0.00000223867,
    x2: 52.4234,
    y2: 25.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#936707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5590_519",
    x1: 32.645,
    y1: 9,
    x2: 44.1439,
    y2: 12.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5590_519",
    x1: 19.7385,
    y1: 9,
    x2: 31.0312,
    y2: 12.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5590_519",
    x1: 32.7444,
    y1: 32.9717,
    x2: 42.8801,
    y2: 37.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5590_519",
    x1: 19.7385,
    y1: 32.9717,
    x2: 29.7921,
    y2: 37.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5590_519",
    x1: 32.8693,
    y1: 24.6201,
    x2: 41.6317,
    y2: 30.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5590_519",
    x1: 19.7385,
    y1: 24.6201,
    x2: 28.5011,
    y2: 30.1624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5590_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.06827550e1e8e12d5a36ae1b9199d33e.svg";
export { ForwardRef as ReactComponent };